import { Module, mapState } from 'vuex'
import { GetterTree, ActionTree, MutationTree } from 'vuex'
import { RootState } from '../types'

export const FailedPermission: PermissionData = {
  HasView: false,
  HasAdd: false,
  HasApprove: false,
  HasDel: false,
  HasEdit: false,
  HasBack: false,
  MenuCode: ''
}
export interface PermissionData {
  HasView: boolean,
  HasAdd: boolean,
  HasApprove: boolean,
  HasDel: boolean,
  HasEdit: boolean,
  HasBack: boolean,
  MenuCode: string
}
export interface PagePermissionState {
  pagePath: string,
  permission: PermissionData
}

export const state: PagePermissionState = {
  pagePath: '',
  permission: {
    HasView: false,
    HasAdd: false,
    HasApprove: false,
    HasDel: false,
    HasEdit: false,
    HasBack: false,
    MenuCode: ''
  }
};

const mutations: MutationTree<PagePermissionState> = {
  SET_PAGEPERMISSION: (mState: PagePermissionState, p: PagePermissionState) => {
    mState.pagePath = p.pagePath
    mState.permission = p.permission
  }
}

const actions: ActionTree<PagePermissionState, RootState> = {
  SetPagePermission({ commit }, permission: PagePermissionState) {
    commit('SET_PAGEPERMISSION', permission)
  }
}

const getters: GetterTree<PagePermissionState, RootState> = {
  pagePermission: (mState) => {
    var s = {
      pagePath: mState.pagePath,
      permission: mState.permission
    }
    return s
  }
}

const namespaced: boolean = true;

export const pagePermission: Module<PagePermissionState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
